import { render, staticRenderFns } from "./curveList.vue?vue&type=template&id=0059ace8"
import script from "./curveList.vue?vue&type=script&lang=js"
export * from "./curveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports